import styles from './style.module.scss';

interface OrderResumeProps {
  namedSelected: { id: number; name: string }[];
}

const OrderResume: React.FC<OrderResumeProps> = ({ namedSelected }) => {
  return (
    <ul className={styles.container}>
      {namedSelected.map((namedSel) => (
        <li key={namedSel.id}>
          <strong>{namedSel.id}</strong> {namedSel.name}
        </li>
      ))}
    </ul>
  );
};

export default OrderResume;
